( function ( $ ) {
	$('.storefront-handheld-footer-bar li.search > a').on("click", function() {
		$(document.body).toggleClass("no-scroll");
		// if($(document.body).hasClass("no-scroll")) {
		// 	$('.storefront-handheld-footer-bar input[type="search"]').focus();
		// }
	});
} )( jQuery );
